var path = require('path');

function rebaseToFrom(option) {
  return option ? path.resolve(option) : process.cwd();
}

module.exports = rebaseToFrom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/options/rebase-to.js
// module id = 727
// module chunks = 0 1